import { render, staticRenderFns } from "./required.vue?vue&type=template&id=2aa05ee4"
import script from "./required.vue?vue&type=script&lang=js"
export * from "./required.vue?vue&type=script&lang=js"
import style0 from "./required.vue?vue&type=style&index=0&id=2aa05ee4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports